var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrivateMobility(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 81.667,
    height: 61.359,
    viewBox: "0 0 81.667 61.359",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8936",
    "data-name": "Rectangle 8936",
    width: 81.667,
    height: 61.359,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16366",
    "data-name": "Group 16366",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16366-2",
    "data-name": "Group 16366",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10599",
    "data-name": "Path 10599",
    d: "M20.863,33.674a7.746,7.746,0,1,1,7.745-7.747,7.754,7.754,0,0,1-7.745,7.747m0-10.447a2.7,2.7,0,1,0,2.7,2.7,2.7,2.7,0,0,0-2.7-2.7",
    transform: "translate(19.976 27.686)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10600",
    "data-name": "Path 10600",
    d: "M3.572,20.505,0,16.943a57.813,57.813,0,0,1,81.667-.114l-1.675,1.895-1.816,1.753a52.778,52.778,0,0,0-74.6.028",
    transform: "translate(0 -0.001)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10601",
    "data-name": "Path 10601",
    d: "M60.265,22.094a37.033,37.033,0,0,0-52.287,0L4.411,18.526a42.085,42.085,0,0,1,59.421,0Z",
    transform: "translate(6.717 9.513)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10602",
    "data-name": "Path 10602",
    d: "M41.577,23.814a20.54,20.54,0,0,0-28.981,0L9.031,20.241a25.6,25.6,0,0,1,36.108,0Z",
    transform: "translate(13.752 19.476)",
    fill: "#444"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateMobility);
export default __webpack_public_path__ + "static/media/private-mobility.15ad90e19afd767705150e96633fe9ff.svg";
export { ForwardRef as ReactComponent };